import { ErrorRouteComponent, Outlet, createRootRouteWithContext, Link } from '@tanstack/react-router'
import { Session } from '@supabase/supabase-js'
import { QueryClient } from '@tanstack/react-query'
import { Box, Button, Container, Flex, Heading, Text } from '@radix-ui/themes'
import { useAuth } from '~/auth/AuthProvider'
import { Spotlight } from '~/components/Spotlight'

export type OpsRouterContext = {
  session: Session
  queryClient: QueryClient
}

const Root = () => {
  const { logout } = useAuth()

  return (
    <Flex direction="column" className="min-h-screen">
      <Flex align="center" justify="between" px="5" py="3" className="border-b border-gray-5">
        <Flex align="center" gap="5">
          <Heading size="4">Willie Ops</Heading>
          <Flex gap="4">
            <Link to="/" activeOptions={{ exact: true }} activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Home</Text>
            </Link>
            <Link to="/stations" activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Stations</Text>
            </Link>
            <Link to="/installations" activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Installations</Text>
            </Link>
            <Link to="/contacts" activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Contacts</Text>
            </Link>
            <Link to="/installation-profiles" activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Hardware</Text>
            </Link>
            <Link to="/compatibility-review" activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Review</Text>
            </Link>
            <Link to="/organizations" activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Organizations</Text>
            </Link>
            <Link to="/stalled" activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Stalled</Text>
            </Link>
            <Link to="/index-captures" activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Index captures</Text>
            </Link>
            <Link to="/orders" activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Order history</Text>
            </Link>
            <Link to="/returns" activeProps={{ className: 'text-[var(--accent-11)]' }}>
              <Text size="2">Returns</Text>
            </Link>
          </Flex>
        </Flex>
        <Flex align="center" gap="3">
          <Button asChild size="2">
            <Link to="/installations/new">Add new installations</Link>
          </Button>
          <Button asChild size="2">
            <Link to="/orders/new">Place order</Link>
          </Button>
          <Button variant="soft" color="gray" size="2" onClick={logout}>
            Sign out
          </Button>
        </Flex>
      </Flex>
      <Box flexGrow="1">
        <Container maxWidth="1200px" p="6">
          <Outlet />
        </Container>
      </Box>
      <Spotlight />
    </Flex>
  )
}

const ErrorComponent: ErrorRouteComponent = (props) => {
  return (
    <Flex direction="column" gap="3" align="center" justify="center" className="h-screen">
      <Heading size="5">Something went wrong</Heading>
      <Text size="2" color="gray">
        {props.error.message}
      </Text>
      <Button mt="4" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </Flex>
  )
}

export const Route = createRootRouteWithContext<OpsRouterContext>()({
  component: Root,
  errorComponent: ErrorComponent
})
